import React from "react";
import { company } from "../mock/mock";

const message = "Hello Shiv Shakti Enterprises, I'd like to enquire about your in-house manufacturing services.";
const waLink = `https://wa.me/${company.whatsappHref}?text=${encodeURIComponent(message)}`;

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <path
      fill="currentColor"
      d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.71 6.402L3.2 28.8l6.56-1.72a12.74 12.74 0 0 0 6.243 1.59h.005c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.8-12.8-12.8zm0 23.04h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.02 1.054 1.073-3.92-.252-.402a10.56 10.56 0 0 1-1.62-5.64c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.11 7.52 3.12a10.56 10.56 0 0 1 3.11 7.52c0 5.87-4.77 10.64-10.63 10.64zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.53-.71-.54l-.61-.01c-.21 0-.55.08-.84.4-.29.32-1.1 1.08-1.1 2.63 0 1.55 1.13 3.05 1.29 3.26.16.21 2.22 3.39 5.38 4.75.75.32 1.34.51 1.8.66.76.24 1.45.21 1.99.13.61-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37z"
    />
  </svg>
);

const WhatsAppFloat = () => (
  <a
    href={waLink}
    target="_blank"
    rel="noopener noreferrer"
    className="group fixed bottom-6 right-6 z-50"
    aria-label="Chat with us on WhatsApp"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />
    <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 group-hover:scale-105 group-hover:shadow-xl transition-transform">
      <WhatsAppIcon className="w-8 h-8" />
    </span>
    <span className="pointer-events-none absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md bg-[#1a1a1a] text-white text-xs font-medium px-3 py-2 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all">
      Chat on WhatsApp
    </span>
  </a>
);

export { WhatsAppIcon };
export default WhatsAppFloat;
